import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: 'cplogin', loadChildren: () => import('./cp-portal/login-cp/login-cp.module').then(m => m.LoginCpModule)
  },
  {
    path: 'sp-login', loadChildren: () => import('./cp-portal/sourcing-partner/sourcing-partner.module').then(m => m.SourcingPartnerModule)
  },
  {
    path: 'cpdashboard', loadChildren: () => import('./cp-portal/cp-portal-dashboard/cp-portal-dashboard.module').then(m => m.CpPortalDashboardModule)
  },
  {
    path: 'cplead', loadChildren: () => import('./cp-portal/cp-leads/cp-leads.module').then(m => m.CpLeadsModule)
  },
  {
    path: 'cpmarketing', loadChildren: () => import('./cp-portal/cp-marketing/cp-marketing.module').then(m => m.CpMarketingModule)
  },
  {
    path: 'cpcampaign', loadChildren: () => import('./cp-portal/cp-campaign/cp-campaign.module').then(m => m.CpCampaignModule)
  },
  {
    path: 'cpLenderCorner', loadChildren: () => import('./cp-portal/cp-lender-corner/cp-lender-corner.module').then(m => m.CpLenderCornerModule)
  },
  {
    path: 'cpQrCode', loadChildren: () => import('./cp-portal/cp-qr-code/cp-qr-code.module').then(m => m.CpQrCodeModule)
  },
  
  { path : 'earned-payout', loadChildren : () => import('./cp-portal/earned-payout/earned-payout.module').then(m => m.EarnedPayoutModule) },

  { path: '', redirectTo: 'cplogin', pathMatch: 'full' },
  { path: 'error', redirectTo: 'cplogin', pathMatch: 'full' },
  { path: '**', redirectTo: '/error', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    useHash: true
  })],
  providers: [AuthGuard],
  exports: [RouterModule]
})
export class AppRoutingModule { }
